import { SITE_ORIGIN } from '@/lib/siteOrigin';

export interface BreadcrumbItem {
  label: string;
  href?: string;
}

const BASE_URL = SITE_ORIGIN;

// Generate schema.org BreadcrumbList JSON-LD
export function generateBreadcrumbSchema(items: BreadcrumbItem[]): object {
  const homeItem = {
    "@type": "ListItem",
    "position": 1,
    "name": "Accueil",
    "item": BASE_URL
  };

  const itemListElement = [
    homeItem,
    ...items.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 2,
      "name": item.label,
      ...(item.href ? { "item": `${BASE_URL}${item.href}` } : {})
    }))
  ];

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": itemListElement
  };
}
